export const SUPPORTED_LOCALES = ["es", "en"];

export function normalizeLocale(value, fallback = "es") {
  const clean = String(value || "").toLowerCase().slice(0, 2);
  return SUPPORTED_LOCALES.includes(clean) ? clean : fallback;
}

export function interpolate(value, params) {
  return String(value).replace(/\{(\w+)\}/g, (_match, key) =>
    Object.prototype.hasOwnProperty.call(params || {}, key) ? String(params[key]) : `{${key}}`);
}

export function translate(catalog, locale, key, params) {
  const value = catalog[locale]?.[key] ?? catalog.es?.[key] ?? key;
  return interpolate(value, params);
}
